import { api } from './client';
import type {
  CompleteSetupRequest,
  CurrentUserDto,
  DevelopmentLoginOptionDto,
  SetupStatusDto,
  UserRole,
} from './types';

export const authApi = {
  me: () => api.get<CurrentUserDto>('/api/auth/me'),

  setupStatus: () => api.get<SetupStatusDto>('/api/setup/status'),

  developmentLoginOptions: () =>
    api.get<DevelopmentLoginOptionDto[]>('/api/auth/development-login'),

  async completeSetup(request: CompleteSetupRequest) {
    const user = await api.post<CurrentUserDto>('/api/setup/complete', request);
    await api.refreshCsrf();
    return user;
  },

  async login(email: string, password: string) {
    const user = await api.post<CurrentUserDto>('/api/auth/login', { email, password });
    await api.refreshCsrf();
    return user;
  },

  async developmentLogin(role: UserRole) {
    const user = await api.post<CurrentUserDto>('/api/auth/development-login', { role });
    await api.refreshCsrf();
    return user;
  },

  async logout() {
    await api.post<void>('/api/auth/logout');
    api.clearCsrf();
  },

  async changePassword(currentPassword: string, newPassword: string) {
    const user = await api.post<CurrentUserDto>('/api/auth/change-password', {
      currentPassword,
      newPassword,
    });
    await api.refreshCsrf();
    return user;
  },
};
